import { HttpClientError } from '@baarbaanet/http-client'
import { HttpClientRequestConfig } from '@baarbaanet/http-client/dist/types'

import { useSnackbar } from './use-snackbar'

interface ExceptionHandlerOptions {
	showSnackbar?: boolean
	ignoredHttpStatusCodes?: number[]
}

export interface HandledError {
	unknownError: boolean
	networkError: boolean
	apiError: boolean
	message: string
	detail: ApiError | null
}

export interface ApiError<D = unknown> {
	httpStatus: number
	status: number
	title: Nullable<string>
	message: Nullable<string>
	request: {
		url: Nullable<string>
		config?: HttpClientRequestConfig<D> | null
	}
}
export function useExceptionHandler(
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	error: any,
	options: ExceptionHandlerOptions = {
		showSnackbar: true,
		ignoredHttpStatusCodes: [401, 406]
	}
) {
	const handledError: HandledError = {
		unknownError: false,
		networkError: false,
		apiError: false,
		message: '',
		detail: null
	}

	if (error instanceof Error && error.name === 'HttpClientError') {
		// this means request reached server bud response has error
		error = error as HttpClientError

		if (error.response) {
			handledError.apiError = true
			const apiError: ApiError = {
				httpStatus: error.response.status,
				status: error.response.data?.result?.status,
				title: error.response.data?.result?.title || null,
				message: error.response.data?.result?.message || null,
				request: {
					url: error.url,
					config: error.config
				}
			}
			handledError.detail = apiError
			handledError.message = apiError.message || '$uikit.anErrorAccoutred'
		} else {
			if (error.message === 'ERR_NETWORK') {
				handledError.networkError = true
				handledError.message = '$uikit.connectionError'
			} else {
				handledError.unknownError = true
				handledError.message = '$uikit.anErrorAccoutred'
			}
		}
	}
	const showSnackbar =
		handledError.message.trim().length &&
		!!options.showSnackbar &&
		(handledError.apiError
			? handledError.detail?.httpStatus &&
				!(options.ignoredHttpStatusCodes || []).includes(
					handledError.detail.httpStatus
				)
			: true)

	if (showSnackbar) {
		useSnackbar().error({ title: handledError.message })
	}

	return handledError
}
